var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgThumbsUpFilled = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78125 1.03125C10.5938 1.21875 11.125 2 10.9688 2.8125L10.875 3.15625C10.7188 4 10.4062 4.78125 10 5.5H14.5C15.3125 5.5 16 6.1875 16 7C16 7.59375 15.6562 8.09375 15.1875 8.34375C15.5312 8.625 15.75 9.03125 15.75 9.5C15.75 10.25 15.2188 10.8438 14.5312 11C14.6562 11.2188 14.75 11.4688 14.75 11.75C14.75 12.4375 14.3125 13 13.6875 13.1875C13.7188 13.2812 13.75 13.4062 13.75 13.5C13.75 14.3438 13.0625 15 12.25 15H9.1875C8.59375 15 8.03125 14.8438 7.53125 14.5L6.3125 13.7188C5.5 13.1562 5 12.2188 5 11.2188V10V8.5V7.75C5 6.8125 5.40625 5.96875 6.125 5.40625L6.34375 5.21875C7.15625 4.53125 7.75 3.625 7.9375 2.5625L8 2.21875C8.1875 1.40625 8.96875 0.875 9.78125 1.03125ZM1 6H3C3.53125 6 4 6.46875 4 7V14C4 14.5625 3.53125 15 3 15H1C0.4375 15 0 14.5625 0 14V7C0 6.46875 0.4375 6 1 6Z",
    fill: "#2F2E99"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThumbsUpFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/thumbs-up-filled.a8bdba7c.svg";
export { ForwardRef as ReactComponent };